import { render, staticRenderFns } from "./NavigationSub.vue?vue&type=template&id=639dca26&"
import script from "./NavigationSub.vue?vue&type=script&lang=js&"
export * from "./NavigationSub.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSub.vue?vue&type=style&index=0&id=639dca26&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports